import Option from './src/option'

Option.install = function (Vue, options) {
  Vue.component(Option.name, Option)
}

export default Option



// WEBPACK FOOTER //
// ./src/components/Option/index.js